import type { ReactNode } from "react";

export const OrganizationSettingsTabWrapper = ({ children }: { children: ReactNode }) => {
	return <div className="p-6">{children}</div>;
};
